import axios from "axios"

class MesNotes {
  constructor() {
    //verif qu'on est sur page #mes-notes; on récupère le nonce; init var mesNotes
    if (document.querySelector("#mes-notes")) {
      axios.defaults.headers.common["X-WP-Nonce"] = presentData.nonce
      this.mesNotes = document.querySelector("#mes-notes")
      this.events()
    }
  }

  events() {
    this.mesNotes.addEventListener("click", e => this.clickHandler(e))
    document.querySelector(".cn-note-submit").addEventListener("click", () => this.createNote())
  }

  clickHandler(e) { 
    if (e.target.classList.contains("old-note-supprimer") || e.target.classList.contains("fa-trash-o")) this.deleteNote(e);
    if (e.target.classList.contains("old-note-modifier") || e.target.classList.contains("fa-pencil") || e.target.classList.contains("fa-times")) this.editNote(e);
    if (e.target.classList.contains("old-note-enregistrer") || e.target.classList.contains("fa-arrow-right")) this.updateNote(e);

  }

  
  // Methods will go here
  editNote(e) {
    //on recherche le parent
    const thisNote = e.target.parentNode.parentNode.parentNode;
    //la 1ère fois y a pas d'attribut mais après ces lignes on aura "data-state=editable ou data-state=annuler"
    if (thisNote.getAttribute("data-state") == "editable") {
      this.makeNoteReadOnly(thisNote)
    } else {
      this.makeNoteEditable(thisNote); 
    }
  }

  makeNoteEditable(thisNote) { 
    thisNote.querySelector(".old-note-modifier").innerHTML = '<i class="fa fa-times" aria-hidden="true"></i> Annuler';
    thisNote.querySelector(".old-note-title").removeAttribute("readonly")
    thisNote.querySelector(".old-note-text").removeAttribute("readonly")
    thisNote.querySelector(".old-note-title").classList.add("note-active-field")
    thisNote.querySelector(".old-note-text").classList.add("note-active-field")
    thisNote.querySelector(".son-enregistrer").classList.add("son-enregistrer-visible")
    thisNote.setAttribute("data-state", "editable")
  }

  makeNoteReadOnly(thisNote) {
    thisNote.querySelector(".old-note-modifier").innerHTML = '<i class="fa fa-pencil" aria-hidden="true"></i> Modifier'
    thisNote.querySelector(".old-note-title").setAttribute("readonly", "true")
    thisNote.querySelector(".old-note-text").setAttribute("readonly", "true")
    thisNote.querySelector(".old-note-title").classList.remove("note-active-field")
    thisNote.querySelector(".old-note-text").classList.remove("note-active-field")
    thisNote.querySelector(".son-enregistrer").classList.remove("son-enregistrer-visible")
    thisNote.setAttribute("data-state", "annuler")
  }

  async deleteNote(e) {
    //on recherche le parent
    const thisNote = e.target.parentNode.parentNode.parentNode;

    try {
      const response = await axios.delete(presentData.root_url + "/wp-json/wp/v2/note/" + thisNote.getAttribute("data-id"))
      thisNote.style.height = `${thisNote.offsetHeight}px`
      setTimeout(function () { thisNote.classList.add("fade-out")}, 20)
      setTimeout(function () { thisNote.remove()  }, 401)

      //si en supprimant on devient inf à 5, on retire le message
      if (response.data.userNoteCount < 5) {
       document.getElementById("msg-note-error").innerHTML = "";

      }
    } catch (e) {alert(e);
      //
      document.getElementById("msg-note-error").innerHTML = "Veuillez nous contacter via le formulaire";

    }
  }

  async updateNote(e) {
    //on recherche le parent attention ici on vient du bouton enregistrer, ya donc que deux grands parents!
    const thisNote = e.target.parentNode.parentNode;

    var ourUpdatedPost = {
      "title": thisNote.querySelector(".old-note-title").value,
      "content": thisNote.querySelector(".old-note-text").value
    }

    try {
      const response = await axios.post(presentData.root_url + "/wp-json/wp/v2/note/" + thisNote.getAttribute("data-id"), ourUpdatedPost)
      this.makeNoteReadOnly(thisNote)
    } catch (e) {
      //console.log("Sorry")
      document.getElementById("msg-note-error").innerHTML = "Veuillez nous contacter via le formulaire";
      document.querySelector(".cn-note-msg").classList.add("active")
    }
  }

  async createNote() {
    var ourNewPost = {
      "title": document.querySelector(".new-note-title").value,
      "content": document.querySelector(".new-note-text").value,
      "status": "publish"
    }

    try {console.log (presentData.root_url );
      const response = await axios.post(presentData.root_url + "/wp-json/wp/v2/note/", ourNewPost)
      
      if (response.data != "Limite atteinte") {
        document.querySelector(".new-note-title").value = ""
        document.querySelector(".new-note-text").value = ""
        document.querySelector("#mes-notes").insertAdjacentHTML(
          "afterbegin",`
            <div data-id="${response.data.id}" class="single-old-note">
                    <div class=son-title-btn>
                        <div class="son-title"><input readonly class="old-note-title" value="${response.data.title.raw}"></div>
                        <div class="son-modifier"><p class="old-note-modifier"><i class="fa fa-pencil" aria-hidden="true"></i>Modifier</p></div>
                        <div class="son-supprimer"><p class="old-note-supprimer"><i class="fa fa-trash-o" aria-hidden="true"></i> Supprimer</p></div>
                    </div>
                    <div class="son-text"><textarea readonly class="old-note-text">${response.data.content.raw}</textarea></div>
                    
                    <div class="son-enregistrer"><p class="old-note-enregistrer"><i class="fa fa-arrow-right" aria-hidden="true"></i> Enregistrer</p></div>
                </div>
          `
        )
       // notice in the above HTML for the new <li> I gave it a class of fade-in-calc which will make it invisible temporarily so we can count its natural height

        //let finalHeight // browser needs a specific height to transition to, you can't transition to 'auto' height
        //let newlyCreated = document.querySelector("#mes-notes li")

        // give the browser 30 milliseconds to have the invisible element added to the DOM before moving on
        //setTimeout(function () {
        //  finalHeight = `${newlyCreated.offsetHeight}px`
        //  newlyCreated.style.height = "0px"
        //}, 30)

        // give the browser another 20 milliseconds to count the height of the invisible element before moving on
        //setTimeout(function () {
        //  newlyCreated.classList.remove("fade-in-calc")
        //  newlyCreated.style.height = finalHeight
        //}, 50)

        // wait the duration of the CSS transition before removing the hardcoded calculated height from the element so that our design is responsive once again
        //setTimeout(function () {
        //  newlyCreated.style.removeProperty("height")
        //}, 450)

      } else {
        document.getElementById("msg-note-error").innerHTML = "Limite atteinte, veuillez supprimer une ancienne note pour faire de la place!";
        document.querySelector(".cn-note-msg").classList.add("active")
      }
    } catch (e) {
      document.getElementById("msg-note-error").innerHTML = "Vous n'êtes pas encore autorisé, veuillez nous contacter via le formulaire";
      document.querySelector(".cn-note-msg").classList.add("active")
    }
  }
}

export default MesNotes
